import { Trait } from '../../trait.type';
import { ModifierPriority } from '../../modifier.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { StatusEffect } from '../../status-effects.type';
import { addModifier } from '../../player.type';
import { DieFace } from '../../face.type';

export class SpellSlingerTrait extends Trait {
  static baseType = TraitType.SpellSlinger;
  static baseTitle = 'Infusing Imbuement';
  static baseText = 'When gaining infusion, also gain 1 imbue of the same element.';
  static baseIcon = 'trait';

  type = SpellSlingerTrait.baseType;
  title = SpellSlingerTrait.baseTitle;
  text = SpellSlingerTrait.baseText;
  icon = SpellSlingerTrait.baseIcon;

  init() {
    this.priority = ModifierPriority.Last;
  }

  modifierAdd(type: StatusEffect, stacks: number, params: any): number {
    if (type == StatusEffect.Infusion) {
      switch (params.infusion) {
        case DieFace.Poison:
          addModifier(this.owner, StatusEffect.Imbue, 1, { imbue: StatusEffect.Poison });
          break;
        case DieFace.Blood:
          addModifier(this.owner, StatusEffect.Imbue, 1, { imbue: StatusEffect.Bleed });
          break;
        case DieFace.Fire:
          addModifier(this.owner, StatusEffect.Imbue, 1, { imbue: StatusEffect.Burning });
          break;
        case DieFace.Ice:
          addModifier(this.owner, StatusEffect.Imbue, 1, { imbue: StatusEffect.Freezing });
          break;
        case DieFace.Lightning:
          addModifier(this.owner, StatusEffect.Imbue, 1, { imbue: StatusEffect.Spark });
          break;
        case DieFace.Earth:
          addModifier(this.owner, StatusEffect.Imbue, 1, { imbue: StatusEffect.Brittle });
          break;
      }
    }
    return stacks;
  }
}

TraitRegistry.register(SpellSlingerTrait.baseType, SpellSlingerTrait);
